import React, { Component } from "react";
import "../../assets/web/assets/mobirise-icons2/mobirise2.css";

import "../../assets/web/assets/mobirise-icons/mobirise-icons.css";
import "../../assets/tether/tether.min.css";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/bootstrap/css/bootstrap-grid.min.css";
import "../../assets/bootstrap/css/bootstrap-reboot.min.css";
import "../../assets/dropdown/css/style.css";
import "../../assets/socicon/css/styles.css";
import "../../assets/theme/css/style.css";
import "../../assets/mobirise/css/mbr-additional.css";
import { Navbar, Nav } from "react-bootstrap";
import logo from "../../assets/images/logowhiterecmin.png";
class Contacts extends Component {
  componentDidMount() {
    document.title = "Contact Us";
  }
  state = {};
  render() {
    return (
      <div>
        <section className="menu menu2 cid-smIpILaFmX" once="menu" id="menu2-0">
          <Navbar
            collapseOnSelect
            expand="lg"
            className="navbar navbar-dropdown navbar-fixed-top navbar-expand-lg"
            style={{ backgroundColor: "rgba(98, 98, 98, 0.5)" }}
          >
            <div className="container-fluid">
              <Navbar.Brand className="navbar-brand" href="#home">
                <span className="navbar-logo">
                  <a href="/">
                    <img
                      src={logo}
                      alt="MassTaxi"
                      title=""
                      style={{ height: "2rem" }}
                    />
                  </a>
                </span>
              </Navbar.Brand>
              {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" /> */}
              <Navbar.Toggle
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarNavAltMarkup"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <div className="hamburger">
                  <span />
                  <span />
                  <span />
                  <span />
                </div>
              </Navbar.Toggle>
              <Navbar.Collapse
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <Nav className="navbar-nav nav-dropdown nav-right">
                  <Nav.Link
                    className="nav-link link text-white text-primary display-4"
                    href="/"
                  >
                    Home
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </div>
          </Navbar>
        </section>

        <section className="contacts2 cid-sE5zdhu4rj" id="contacts2-26" style={{ height: "90vh" }}>
          <div className="container">
            <div className="mbr-section-head">
              <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                <strong>Contacts</strong>
              </h3>
            </div>
            <div className="row justify-content-center mt-4">
              <div className="card col-12 col-md-6">
                <div className="card-wrapper">
                  <div className="image-wrapper">
                    <span className="mbr-iconfont mobi-mbri-phone mobi-mbri" />
                  </div>
                  <div className="text-wrapper">
                    <h6 className="card-title mbr-fonts-style mb-1 display-5">
                      <strong>Phone</strong>
                    </h6>
                    <p className="mbr-text mbr-fonts-style display-5">
                      <a href="tel:+251986558559" className="text-primary">
                        +251 986 55 85 59
                      </a>
                    </p>
                    <p className="mbr-text mbr-fonts-style display-5">
                      <a href="tel:+251930599818" className="text-primary">
                        +251 930 59 98 18
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="card col-12 col-md-6">
                <div className="card-wrapper">
                  <div className="image-wrapper">
                    <span className="mbr-iconfont mobi-mbri-letter mobi-mbri" />
                  </div>
                  <div className="text-wrapper">
                    <h6 className="card-title mbr-fonts-style mb-1 display-5">
                      <strong>Email</strong>
                    </h6>
                    <p className="mbr-text mbr-fonts-style display-5">
                      <a
                        href="mailto:masstaxiads@gmail.com"
                        className="text-primary"
                      >
                        masstaxiads@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <br />
        <br />
        <br />
        <br />

        <section
          className="footer3 cid-smIvGalAcO"
          once="footers"
          id="footer3-1u"
        >
          <div className="container">
            <div className="media-container-row align-center mbr-white">
              <div className="row row-links">
                <ul className="foot-menu">
                  <li className="foot-menu-item mbr-fonts-style display-7">
                    <a href="/" className="text-primary">
                      Home
                    </a>
                  </li>
                  <li className="foot-menu-item mbr-fonts-style display-7">
                    <a href="/contacts" className="text-primary">
                      Contact Us
                    </a>
                  </li>
                  <li className="foot-menu-item mbr-fonts-style display-7">
                    <a href="/driver" className="text-primary">
                      Driver
                    </a>
                  </li>
                  <li className="foot-menu-item mbr-fonts-style display-7">
                    <a href="/business_login" className="text-primary">
                      Login
                    </a>
                  </li>
                </ul>
              </div>
              <div className="row social-row">
                <div className="social-list align-right pb-2">
                  <div className="soc-item">
                    <a
                      href="https://www.facebook.com/masstaxiads"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <span className="socicon-facebook socicon mbr-iconfont mbr-iconfont-social" />
                    </a>
                  </div>
                  <div className="soc-item">
                    <a
                      href="https://www.youtube.com/channel/UCsBTZqPsr-ceq197Fz1gYcw"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <span className="socicon-youtube socicon mbr-iconfont mbr-iconfont-social" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="row row-copirayt">
                <p className="mbr-text mb-0 mbr-fonts-style mbr-white align-center display-7">
                  © MassTaxi 2021. Service Provided by DAST ICT Solutions PLC.
                  All Rights Reserved.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Contacts;
